"use client";

import { Row, Col, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import TotalSales from "./TotalSales";
import TotalOrders from "./TotalOrders";
import TotalProfit from "./TotalProfit";
import TotalRevenue from "./TotalRevenue";
import DateTimePickerDemo from "./DateTimePickerDemo";
import { fetchComparisonStats } from "../../../../api/api";

const Stats = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!user?.id) return;

    fetchComparisonStats(user.id)
      .then(setStats)
      .catch(console.error);
  }, [user]);

  return (
    <>
      <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4">
        <h3 className="fs-24 fw-normal mb-0">Member Analytics</h3>

        <div className="d-flex flex-wrap gap-3 align-items-center">
          <DateTimePickerDemo />

          <Button className="btn btn-primary py-1 px-3 rounded-3">
            Export CSV
          </Button>
        </div>
      </div>

      <Row>
        <Col sm={6} xl={3}>
          <TotalSales data={stats} />
        </Col>

        <Col sm={6} xl={3}>
          <TotalOrders data={stats} />
        </Col>

        <Col sm={6} xl={3}>
          <TotalProfit data={stats} />
        </Col>

        <Col sm={6} xl={3}>
          <TotalRevenue data={stats} />
        </Col>
      </Row>
    </>
  );
};

export default Stats;